import * as React from 'react'

function IconLeaf2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={56}
      height={37}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.15 4.285l36.07 21.56L.01 9.896s16.082 40.33 55.007 20.854c-.002.014-11.881-43-46.866-26.464z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf2
